import { clone, equals } from 'ramda';

import { type IJsonQueryHighway } from '../api-models/common/json_query';

import { setGeo } from './helpers';
import { type NonEmptyArray, type TJsonQuery } from './types';

export function setHighways(jsonQuery: TJsonQuery): (...geoHighways: NonEmptyArray<IJsonQueryHighway>) => TJsonQuery {
  return (...geoHighways) => {
    const geo = (jsonQuery.geo && clone(jsonQuery.geo.value)) || [];

    const nextGeo = geo.filter(g => g.type !== 'highway' || geoHighways.some(h => h.id === g.id));
    const addedGeoHighways = geoHighways.filter(h => !geo.some(g => equals(h, g)));

    return setGeo()(jsonQuery)([...nextGeo, ...addedGeoHighways]);
  };
}
